import { render, staticRenderFns } from "./FlowNode.vue?vue&type=template&id=3748da61"
import script from "./FlowNode.vue?vue&type=script&lang=js"
export * from "./FlowNode.vue?vue&type=script&lang=js"
import style0 from "./FlowNode.vue?vue&type=style&index=0&id=3748da61&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3748da61')) {
      api.createRecord('3748da61', component.options)
    } else {
      api.reload('3748da61', component.options)
    }
    module.hot.accept("./FlowNode.vue?vue&type=template&id=3748da61", function () {
      api.rerender('3748da61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreatedFlow/modules/FlowNode.vue"
export default component.exports